import React from 'react';
import createNavComponent from '../../bdcoreCandidates/Navigation';
import MenuModal from '../Header/MenuModal';
import ToggleNavAreaLinks from '../Header/ToggleNavAreaLinks';
import FooterNavAreaLinks from '../FooterNavAreaLinks';

export default createNavComponent({
  menus: [
    {
      meta: {
        key: 'shop_by_area_modal',
      },
      render: props => {
        const { className, activateMenu, headingClassName } = props; //eslint-disable-line
        return (
          <div className={className}>
            <MenuModal>
              <span onClick={activateMenu('shop_by_area_modal')} role="button" tabIndex={0} className={headingClassName}>Shop By Area</span>
            </MenuModal>
          </div>
        );
      },
    },
    {
      meta: {
        key: 'shop_by_area',
      },
      render: props => {
        const { className, activateMenu, headingClassName, subMenuClassName } = props; //eslint-disable-line
        return (
          <ToggleNavAreaLinks />
        );
      },
    },
    {
      meta: {
        key: 'footer_area_nav',
      },
      render: props => {
        const { className, activateMenu, headingClassName, subMenuClassName } = props; //eslint-disable-line
        return (
          <FooterNavAreaLinks className="NavMenu_areaWrapper" />
        );
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/components/Navigation/Nav.js